import React from 'react';
import CurrencyFormatter from '../../utils/text/CurrencyFormatter';
import Box from '../boxes/Box';
import Typography from '../typography/Typography';
import Chart from './Chart';

type Props = {
  label: string;
  price: number;
  data: {};
  onClick?: () => void;
};

export const LastBillingTiny = ({ label, price, data, onClick }: Props) => {
  return (
    <Box size="medium" type="bordered">
      <div className="col-span-4 md:col-span-1">
        <Typography tag="span" type="label">
          {label}
        </Typography>
        <Typography tag="h2" type="subtitle">
          <CurrencyFormatter price={price} />
        </Typography>
      </div>
      <div className="col-span-4 md:col-span-3 w-full h-full">
        <Chart data={data.results} onClick={onClick} />
      </div>
    </Box>
  );
};

export default LastBillingTiny;
